import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import CustomLink from 'components/CustomLink';
import EventCard from 'components/cards/entities/EventCard';
import OffsetSlider from 'components/sliders/OffsetSlider';
import Section from 'components/Section';
import SizeDependedBlock from 'components/SizeDependedBlock';

import { EntitiesPropType } from 'propTypes/common';

import styles from './styles.module.scss';

const Afisha = ({ events, linkBlockClassName }) => {
	const renderSlider = (eventChunks) => (
		<OffsetSlider>
			{eventChunks.map((chunk) => (
				<div key={_(chunk).pluck('_id').toString()}>
					{chunk.map((event) => (
						<EventCard key={event._id} entity={event} className={styles.card} />
					))}
				</div>
			))}
		</OffsetSlider>
	);

	return (
		<Section title="Афиша Пушкинской карты" align="center" titleSize="medium">
			<SizeDependedBlock breakpoint="mobileLarge">
				{renderSlider(_(events).chunk(1))}
				{renderSlider(_(events).chunk(2))}
			</SizeDependedBlock>
			<div className={linkBlockClassName}>
				<CustomLink
					className={styles.link}
					title="Посмотреть все события"
					href="/pushkinskaya-karta/afisha"
					theme="primaryButton"
					next
				/>
			</div>
		</Section>
	);
};

Afisha.propTypes = {
	events: EntitiesPropType.isRequired,
	linkBlockClassName: PropTypes.string.isRequired
};

export default Afisha;
